import { render, staticRenderFns } from "./MobileChatSheet.vue?vue&type=template&id=02565da6"
import script from "./MobileChatSheet.vue?vue&type=script&lang=js"
export * from "./MobileChatSheet.vue?vue&type=script&lang=js"
import style0 from "./MobileChatSheet.vue?vue&type=style&index=0&id=02565da6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports